export default "__VITE_ASSET__d01fb17b__"